import React from 'react';
import './Pages.css';

function Terms() {
  return (
    <div className="container">
      <div className="page-content">
        <h1>Terms and Conditions</h1>
        <p className="last-updated">Last Updated: January 2025</p>

        <div className="page-section">
          <p>
            By accessing or using Stickyours.com, you agree to the following Terms and Conditions.
            If you do not agree, please do not use our website or tools.
          </p>
        </div>

        <div className="page-section">
          <h2>Use of Our Services</h2>
          <p>
            Stickyours.com provides an Image to Sticker Generator for personal and commercial use,
            unless stated otherwise.
          </p>
          <p>You agree:</p>
          <ul>
            <li>To use the tools lawfully</li>
            <li>Not to upload illegal, copyrighted, or offensive content</li>
            <li>Not to misuse or attempt to disrupt the website or services</li>
          </ul>
        </div>

        <div className="page-section">
          <h2>Intellectual Property</h2>
          <ul>
            <li>
              Stickyours.com and its content (branding, text, design, tools) are owned by
              Stickyours unless otherwise stated.
            </li>
            <li>
              You retain ownership of images you upload and stickers you generate.
            </li>
          </ul>
        </div>

        <div className="page-section">
          <h2>User Content</h2>
          <p>
            You are solely responsible for the images you upload. By using our tools, you confirm that:
          </p>
          <ul>
            <li>You own the rights to the images or have permission to use them</li>
            <li>Your content does not violate any laws or third-party rights</li>
          </ul>
        </div>

        <div className="page-section">
          <h2>Availability</h2>
          <p>
            We aim to keep Stickyours.com available at all times, but we do not guarantee
            uninterrupted access. Features may change or be removed without notice.
          </p>
        </div>

        <div className="page-section">
          <h2>Limitation of Liability</h2>
          <p>Stickyours.com is provided "as is". We are not responsible for:</p>
          <ul>
            <li>Loss of data</li>
            <li>Business losses</li>
            <li>Errors or inaccuracies in generated stickers</li>
          </ul>
          <p>Use our tools at your own risk.</p>
        </div>

        <div className="page-section">
          <h2>Changes to Terms</h2>
          <p>
            We may update these Terms and Conditions at any time. Continued use of the site means
            you accept the updated terms.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Terms;
